import { all, call, delay, put, takeLatest } from "redux-saga/effects";
import { ReduxActionTypes } from "constants/ReduxActionConstants";
import { ApiResponse } from "types/ApiTypes";
import { toast } from "@appsmith/ads";
import log from "loglevel";
import AccountDeletionApi from "api/AccountDeletionApi";
import {
  fetchAccountDeletionPreflightSuccess,
  deleteAccountSuccess,
  deleteAccountFailed,
} from "actions/AccountDeletionActions";
import { isValidResponse } from "./utilitySaga";
import { logoutUser } from "./UserSaga";
import {
  createMessage,
  ACCOUNT_DELETE_SUCCESS,
  ACCOUNT_DELETE_ERROR,
  ACCOUNT_DELETE_PREFLIGHT_ERROR,
} from "constants/Messages";

function* onFetchPreflight() {
  try {
    const response: ApiResponse<any> = yield call(AccountDeletionApi.preflight);
    const isValid: boolean = yield call(isValidResponse, response);
    if (isValid) {
      yield put(fetchAccountDeletionPreflightSuccess(response.data));
    } else {
      throw new Error(createMessage(ACCOUNT_DELETE_PREFLIGHT_ERROR));
    }
  } catch (error: any) {
    log.error(error);
    toast.show(createMessage(ACCOUNT_DELETE_PREFLIGHT_ERROR), {
      kind: "error",
    });
  }
}

function* onDeleteAccount(action: { type: string; payload: string }) {
  try {
    const response: ApiResponse<any> = yield call(
      AccountDeletionApi.deleteAccount,
      action.payload,
    );
    const isValid: boolean = yield call(isValidResponse, response);
    if (isValid) {
      yield put(deleteAccountSuccess());
      toast.show(createMessage(ACCOUNT_DELETE_SUCCESS), { kind: "success" });
      yield delay(2000);
      yield call(logoutUser);
    } else {
      throw new Error(createMessage(ACCOUNT_DELETE_ERROR));
    }
  } catch (error: any) {
    log.error(error);
    yield put(deleteAccountFailed());
    toast.show(createMessage(ACCOUNT_DELETE_ERROR), { kind: "error" });
  }
}

export function* AccountDeletionSaga() {
  yield all([
    takeLatest(
      ReduxActionTypes.FETCH_ACCOUNT_DELETION_PREFLIGHT,
      onFetchPreflight,
    ),
    takeLatest(ReduxActionTypes.DELETE_ACCOUNT, onDeleteAccount),
  ]);
}
